/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElSharedModule } from '../shared/shared.module';
import { ElIconModule } from '../icon/icon.module';

import { ElToastrContainerRegistry, ElToastrService } from './toastr.service';
import { ElToastComponent } from './toast.component';
import { ElToastrContainerComponent } from './toastr-container.component';
import { EL_TOASTR_CONFIG, ElToastrConfig } from './toastr-config';


@NgModule({
  imports: [ElSharedModule, ElOverlayModule, ElIconModule],
  declarations: [ElToastrContainerComponent, ElToastComponent],
  entryComponents: [ElToastrContainerComponent, ElToastComponent],
})
export class ElToastrModule {
  static forRoot(toastrConfig: Partial<ElToastrConfig> = {}): ModuleWithProviders {
    return <ModuleWithProviders> {
      ngModule: ElToastrModule,
      providers: [
        ElToastrService,
        ElToastrContainerRegistry,
        { provide: EL_TOASTR_CONFIG, useValue: toastrConfig },
      ],
    };
  }
}
